import { render, staticRenderFns } from "./ProductPriceMobile.vue?vue&type=template&id=9d97c196&scoped=true"
import script from "./ProductPriceMobile.vue?vue&type=script&lang=js"
export * from "./ProductPriceMobile.vue?vue&type=script&lang=js"
import style0 from "./ProductPriceMobile.vue?vue&type=style&index=0&id=9d97c196&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d97c196",
  null
  
)

export default component.exports